import actions from '../actions/search';
import { normalize } from 'components/search-results/helper';

const defaultState = {
    isFetching: 'false'
};

export default (state = defaultState, action) => {
    const requestSearchResults = () => {
        return {
            ...state,
            isFetching: 'fetching'
        };
    };

    const receiveSearchResults = () => {
        const { payload } = action;
        return {
            ...state,
            isFetching: 'false',
            ...normalize(payload)
        };
    };

    const updateRouting = () => {
        const { payload } = action;
        return {
            ...state,
            routing: {
                ...payload
            }
        };
    };

    const setSingleFilter = () => ({
        ...state,
        filters: {
            ...state.filters,
            [action.payload.filter]: {
                ...state.filters[action.payload.filter],
                selectedValue: action.payload.value
            }
        }
    });

    const setCategoryFilter = () => ({
        ...state,
        activeCategory: action.payload
    });

    const def = () => state;

    const reducers = {
        [actions.actionTypes.REQUEST_SEARCH_RESULTS]: requestSearchResults,
        [actions.actionTypes.RECEIVE_SEARCH_RESULTS]: receiveSearchResults,
        [actions.actionTypes.UPDATE_ROUTING]: updateRouting,
        [actions.actionTypes.SET_SINGLE_FILTER]: setSingleFilter,
        [actions.actionTypes.SET_ACTIVE_CATEGORY]: setCategoryFilter
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/search.js